<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết cuộc gọi</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin merchant</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.merchantName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Loại KH<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.merchantType }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên người đại diện<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.customerName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Email<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.email }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số điện thoại chính<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.merchantPhoneNumber }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Chi tiết cuộc gọi</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Liên hệ đến: <span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.toNumber }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Nhân sự<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.username }} - {{ item.userEmail }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG khởi tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG thực hiện<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ item.createCallIoTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >TG gọi<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ getTiming(item.endCallIoTime, item.createCallIoTime) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Chiều gọi<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ item.direction | formatDirection }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Kết quả<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span v-if="item.crmResult"
                    >{{ item.crmResult | resultCall(resultStatusCalls) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >File ghi ấm<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a :href="item.record" target="_blank" style="color: blue"
                    >{{ item.record }} <i class="bx bxs-microphone" style="font-size: 20px"></i
                  ></a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import moment from 'moment'
  import { CallIoService } from '@/services/callio.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import pad from 'lodash/pad'
  export default {
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        Config,
        item: {},
        showLoading: false,
        resultStatusCalls: null,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      this.fetchResultStatusCall()
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const res = await CallIoService.getDetailCallIO({ id: this.$route.params.id })
          this.item = res.data
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      getTiming(endCallIoTime, createCallIoTime) {
        if (!endCallIoTime) return ''
        const end = moment(endCallIoTime)
        const start = moment(createCallIoTime)
        const duration = moment.duration(end.diff(start))
        return `${pad(duration.hours(), 2, '0')}:${pad(
          duration.minutes(),
          2,
          '0'
        )}:${pad(duration.seconds(), 2, '0')}`
      },
      async fetchResultStatusCall() {
        const response = await CallIoService.getResultStatusCall()
        this.resultStatusCalls = response.data
      },
    },
  }
</script>
<style scoped>
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }
  .detail {
    cursor: pointer;
    color: blue;
  }
  .text-start {
    text-align: start;
    padding-left: 3px;
  }
  h6 {
    font-weight: 600;
    font-size: 14px;
  }
</style>
